/**
 * --------------------------------------------------------------------------
 * CoreUI PRO index.esm.js
 * Licensed under MIT (Licensed under MIT (https://coreui.io/pro/license/)
 * --------------------------------------------------------------------------
 */

import Alert from './src/alert.js'
import Button from './src/button.js'
import Calendar from './src/calendar.js'
import Carousel from './src/carousel.js'
import Collapse from './src/collapse.js'
import DatePicker from './src/date-picker.js'
import DateRangePicker from './src/date-range-picker.js'
import Dropdown from './src/dropdown.js'
import LoadingButton from './src/loading-button.js'
import Modal from './src/modal.js'
import MultiSelect from './src/multi-select.js'
import Navigation from './src/navigation.js'
import OffCanvas from './src/offcanvas.js'
import Popover from './src/popover.js'
import RangeSlider from './src/range-slider.js'
import Rating from './src/rating.js'
import ScrollSpy from './src/scrollspy.js'
import Sidebar from './src/sidebar.js'
import Tab from './src/tab.js'
import TimePicker from './src/time-picker.js'
import Toast from './src/toast.js'
import Tooltip from './src/tooltip.js'

export default {
  Alert,
  Button,
  Calendar,
  Carousel,
  Collapse,
  DatePicker,
  DateRangePicker,
  Dropdown,
  LoadingButton,
  Modal,
  MultiSelect,
  Navigation,
  OffCanvas,
  Popover,
  RangeSlider,
  Rating,
  ScrollSpy,
  Sidebar,
  Tab,
  TimePicker,
  Toast,
  Tooltip
}
